import axios from "axios";
import { store_addons, get_addons, delete_addon } from "../../../Api/Api";
import { toast } from "react-toastify";

const create_addons_data_Action = async (data) => {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const headers = {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
  };
  const response = await axios({
    method: "POST",
    baseURL: `${store_addons}`,
    headers: headers,
    data: data,
  });
  if (response?.status == 200) {
    toast.success("addons created  Successfully", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
  return response.data;
};

const get_all_addons_data = async (id) => {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const headers = {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
  };
  const response = await axios({
    method: "GET",
    baseURL: `${get_addons}/${id}`,
    headers: headers,
    // data: data,
  });
  return response.data;
};

const delete_addon_Action = async (id) => {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const headers = {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
  };
  const response = await axios({
    method: "POST",
    baseURL: `${delete_addon}`,
    headers: headers,
    data: id,
  });
  if (response?.status == 200) {
    toast.success(" deleted Successfully", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
  return response.data;
};
const addons_Service = {
  create_addons_data_Action,
  get_all_addons_data,
  delete_addon_Action,
};
export default addons_Service;
